import { getRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

/**
 * Fetches tournament pools analytics data ordered by playerCount descending
 * @returns {Promise<Array>} Array of tournament pools with analytics data
 */
export const getTournamentAnalytics = async () => {
  const data = {}
  try {
    const { response, logComplete } = await getRequest('analytics/tournaments', data)

    logger.log('getTournamentAnalytics response:', response)
    logComplete()
    return response
  } catch (error) {
    logger.error('getTournamentAnalytics', error)
    throw error
  }
}
